var Bavaria = "Baviera";
var Berlin = "Berlín";
var Brandenburg = "Brandeburgo";
var Bremen = "Bremen";
var Hamburg = "Hamburgo";
var Hesse = "Hesse";
var Saarland = "Sarre";
var Saxony = "Sajonia";
var Thuringia = "Turingia";
var DEStates = {
	"Baden-Wuerttemberg": "Baden-Wurtemberg",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "Mecklemburgo-Pomerania Occidental",
	"Lower Saxony": "Baja Sajonia",
	"North Rhine-Westphalia": "Renania del Norte-Westfalia",
	"Rhineland-Palatinate": "Renania-Palatinado",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "Sajonia-Anhalt",
	"Schleswig-Holstein": "Schleswig-Holstein",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
